import { render, staticRenderFns } from "./ImVerified.vue?vue&type=template&id=3211ae3e&scoped=true"
import script from "./ImVerified.vue?vue&type=script&lang=js"
export * from "./ImVerified.vue?vue&type=script&lang=js"
import style0 from "./ImVerified.vue?vue&type=style&index=0&id=3211ae3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3211ae3e",
  null
  
)

export default component.exports